import { render, staticRenderFns } from "./admin-notification.vue?vue&type=template&id=37d54f6c&lang=pug&"
import script from "./admin-notification.vue?vue&type=script&lang=js&"
export * from "./admin-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports